<template>
  <div>
    <div class="content-header"></div>
    <div class="content-wrapper">
      <el-row>
        <el-col :span="6" class="content-left">
          <IndexMenu ref="indexMenu" />
        </el-col>
        <!-- 右侧内容 -->
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </el-row>
    </div>
  </div>
</template>

<script>
import IndexMenu from './components/index-menu.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'bcc',
  components: {
    IndexMenu
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$refs.indexMenu.getStatisticList()
    })
  },
  created () {
  },
  methods: {
    getRequest (val) {
      this.orderList = []
      this.tradeType = this.$route.params.tradeType
      if (this.tradeType === 'all' || this.tradeType === 'closed') {
        if (this.tradeType === 'closed') {
          this.queryParams.applyStatus = '900'
        }
        this.getAllList()
      }
    },
    // 获取所有订单
    getAllList () {
      this.$store
        .dispatch('getAllList', this.queryParams)
        .then((response) => {
          if (response.data.resultCode === '0') {
            this.orderList = response.data.resultData.tradeApplyList || []
            this.total = response.data.resultData.pageInfo.totalCounts
          }
        })
        .catch(() => { })
    }
  }
  // beforeRouteLeave(to, from, next) {
  //   if (to.name === "bcc-order-info") {
  //     localStorageUtils.set("queryParams", JSON.stringify(this.queryParams));
  //   } else {
  //     localStorageUtils.remove("queryParams");
  //   }
  //   next();
  // },
}
</script>

<style lang="scss" scoped>
.content-header {
  height: 100px;
  background: url('../../../assets/images/banner-menu.jpg') center no-repeat;
  background-size: cover;
}
.trade-nav-panel {
  width: 80%;
  min-height: 400px;
  margin: 0 auto;
  background: $base-white;
  ::v-deep .el-card__header {
    height: 70px;
    line-height: 35px;
  }

  ::v-deep .el-card__body {
    padding: 0;
  }

  .panel-header {
    font-size: 16px;
    font-weight: 700;
  }
  ::v-deep .el-menu {
    border-right: 0;
  }
  ::v-deep .el-menu-item {
    border-bottom: 1px solid $base-grey5;
  }

  ::v-deep .el-menu-item.is-active {
    color: $base-red;
  }
}

.content-wrapper {
  min-height: calc(100vh - 320px) !important;

  .content-left,
  .content-right {
    height: 100%;
    box-sizing: border-box;
    a {
      text-decoration: none;
      color: #000;
    }
  }
  .content-left {
    padding-right: $content-middle;
  }
}
</style>
